import { useDispatch } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { BaseInfoActions } from '../../../../Reducer/BaseInfoReducer';
import { setRowData } from '../../../../Reducer/GridReducer';
import { apiRequest } from './../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import useSearchMutaion from './../../../../hooks/apis/useSearchMutaion';
import useDeleteMutation from '../../../../hooks/apis/useDeleteMutaion';
import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { PLA_BASIC_Schema } from './PLA_BASIC_Schema';

/**
 * 사업장(Plant) 기본정보 관련 React Query 훅 모음
 * - 기본 조회(useQuery): usePlantBasicList
 * - 조건 조회(useMutation 기반): usePlantManager, usePlantInternalIds
 * - 삭제/저장(useMutation 기반): useDeletePlant, useSavePlant1/2/3
 * 
 * 만약 MUTATION 훅에서 공통 응답 처리 외에 추가 성공 콜백이 필요하면
 * successOptions 파라미터로 onSuccess 콜백 함수를 넘겨줄 수 있다.
 * EX)
 *    export const usePlantManager = () => {
 *      return useSearchMutaion(
 *        (params) => {
 *          const encryptedParams = {
 *            CustCd: Commons.EncryptAES(params.CustCd) || '',
 *          };
 *          return apiRequest('post', Global.urls.Plant.getPlaBasicR2, encryptedParams);
 *        },
 *        {
 *          onSuccess: (rows) => {
 *            console.log('manager 전용 성공처리', rows);
 *          },
 *          dateKey: 'cmBirth', 
 *        }
 *      );
};
 */
export const useSearch1 = (options = {}) => {
  const dispatch = useDispatch();
  const params = mapParamsBySchema(PLA_BASIC_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['plant', 'getPlaBasicR1', params],
    queryFn: () => apiRequest('post', Global.urls.Plant.getPlaBasicR1, params),
    enabled: true, // 자동 실행 여부
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: (rows) => {
        dispatch(setRowData({ gridId: 'grid1', rowData: rows }));
        dispatch(BaseInfoActions.setCustInfo(rows));
      },
    });
  }, [query.isSuccess, query.data, dispatch]);

  return query;
};
export const useSearch2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const encryptedParams = mapParamsBySchema(
      PLA_BASIC_Schema.mapper.search2,
      context
    );
    return apiRequest('post', Global.urls.Plant.getPlaBasicR2, encryptedParams);
  }, successOptions);
};

export const useSearch3 = (successOptions) => {
  return useSearchMutaion((context) => {
    const encryptedParams = mapParamsBySchema(
      PLA_BASIC_Schema.mapper.search3,
      context
    );
    return apiRequest('post', Global.urls.Plant.getPlaBasicR3, encryptedParams);
  }, successOptions);
};

export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, PLA_BASIC_Schema.mapper.delete1);

    return apiRequest('post1', Global.urls.Plant.deletePlaBasicD1, payload);
  }, options);
};

export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, PLA_BASIC_Schema.mapper.save1);

    return apiRequest('post1', Global.urls.Plant.savePlaBasicU1, payload);
  }, options);
};

export const useSave2 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, PLA_BASIC_Schema.mapper.save2);

    return apiRequest('post1', Global.urls.Plant.savePlaBasicU2, payload);
  }, options);
};

export const useSave3 = (custCd, options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, PLA_BASIC_Schema.mapper.save3, {
      custCd,
    });
    return apiRequest('post1', Global.urls.Plant.savePlaBasicU3, payload);
  }, options);
};
